import type { GetInitialValuesParams, InitialValues } from '../types';

export const getInitialValues = ({
  isTopicPost,
  topicId,
  userPost,
}: GetInitialValuesParams): InitialValues => {
  const initialValues = {
    post: {
      content_html: userPost?.content_html ?? '',
      embed: userPost?.embed ?? {},
      storage_attachments: userPost?.uploads ?? [],
      storage_uploads: userPost?.attached_images ?? [],
    },
  };

  return isTopicPost && topicId
    ? {
        ...initialValues,
        post: {
          ...initialValues.post,
          tag_ids: userPost?.tag_ids,
          /** topic_id is mandatory inside a group */
          topic_id: topicId,
        },
      }
    : initialValues;
};
